/**
 * Native platform
 */
export const NATIVE = 'NATIVE' as const;

/**
 * Server platform
 */
export const SERVER = 'SERVER' as const;

/**
 * Web platform
 */
export const WEB = 'WEB' as const;

/**
 * Platforms
 */
export const PLATFORM = {
  NATIVE,
  SERVER,
  WEB,
} as const;
